import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

// Premiere countdown in Brisbane time, driven by the server clock. Swaps to onLive() when the moment arrives.
export default function PremiereCountdown({ premiereAt, serverNow, onLive }) {
  const [offset] = useState(() => (serverNow ? Date.parse(serverNow) - Date.now() : 0));
  const [left, setLeft] = useState(() => Date.parse(premiereAt) - (Date.now() + offset));
  useEffect(() => {
    const t = setInterval(() => {
      const l = Date.parse(premiereAt) - (Date.now() + offset);
      setLeft(l);
      if (l <= 0) { clearInterval(t); onLive?.(); }
    }, 1000);
    return () => clearInterval(t);
  }, [premiereAt, offset, onLive]);
  if (!premiereAt) return <p className="font-display font-extrabold text-lg text-[#FFD93D]" data-testid="premiere-date-tbc">Premiere Date Coming Soon</p>;
  if (left <= 0) return <p className="inline-flex items-center gap-2 font-display font-extrabold text-lg text-[#FFD93D]" data-testid="premiere-countdown-live"><Clock className="w-5 h-5" /> It's premiere time!</p>;
  const s = Math.floor(left / 1000);
  const parts = [["Days", Math.floor(s / 86400)], ["Hours", Math.floor((s % 86400) / 3600)], ["Minutes", Math.floor((s % 3600) / 60)], ["Seconds", s % 60]];
  return (
    <div className="inline-flex flex-wrap items-center gap-2 sm:gap-3" data-testid="premiere-countdown" role="timer" aria-live="off">
      {parts.map(([u, v]) => (
        <span key={u} className="min-w-[68px] sm:min-w-[84px] rounded-2xl bg-[#19324A] border-2 border-[#FFD93D] text-white text-center py-2 px-2">
          <span className="block font-display font-extrabold text-2xl sm:text-3xl leading-none tabular-nums" data-testid={`premiere-${u.toLowerCase()}`}>{String(v).padStart(2, "0")}</span>
          <span className="block text-[10px] uppercase tracking-wider text-[#FFD93D] mt-1">{u}</span>
        </span>
      ))}
    </div>
  );
}
